import React from 'react'
import App from './App'
import AppContext from './AppContext'

export default function AppPreparations() {

    
    return (
        <AppContext>
            <App />
        </AppContext>
    )
}